import { IGoodCategory, IGoodCategoryUseCase } from "@lib";
import { IGoodCategoryCreateDto, IGoodCategoryUpdateDto } from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class GoodCategoryUseCase implements IGoodCategoryUseCase {
    public async select(companyId: string): Promise<IGoodCategory[]> {
        try {
            const response = await Api.get<IGoodCategory[]>(`/companies/${companyId}/lists/categories`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async selectAll(companyId: string): Promise<IGoodCategory[]> {
        try {
            const response = await Api.get<IGoodCategory[]>(`/companies/${companyId}/lists/categories`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async get(companyId: string, id: string): Promise<IGoodCategory> {
        try {
            const response = await Api.get<IGoodCategory>(`/companies/${companyId}/lists/categories/${id}`);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async create(companyId: string, dto: IGoodCategoryCreateDto): Promise<IGoodCategory> {
        try {
            const response = await Api.post<IGoodCategory>(`/companies/${companyId}/lists/categories`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async createMany(companyId: string, dtos: IGoodCategoryCreateDto[]): Promise<IGoodCategory[]> {
        try {
            const response = await Api.post<IGoodCategory[]>(`/companies/${companyId}/lists/categories/many`, dtos);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async update(companyId: string, id: string, dto: IGoodCategoryUpdateDto): Promise<IGoodCategory> {
        try {
            const response = await Api.put<IGoodCategory>(`/companies/${companyId}/lists/categories/${id}`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async archive(companyId: string, id: string): Promise<void> {
        try {
            await Api.delete<void>(`/companies/${companyId}/lists/categories/${id}`);
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
